
<script>

import config from '../../libs/config.json';
import func from '../../libs/functions.js';
import Axios from "axios";
import api from '../../api'
import _ from 'lodash'

import _facebook from '../../libs/facebook';
import _instagram from '../../libs/instagram';
import _youtube from '../../libs/youtube';

import { _is } from './mixins/_is'
import { getPlatformImage } from './mixins/getPlatformImage'

import _system from '../../libs/system';

import AOS from 'aos'
import 'aos/dist/aos.css'

  import iziToast from 'izitoast'
  import 'izitoast/dist/css/iziToast.min.css';

import { mapGetters, mapActions } from "vuex";

import  InboxFilter from "./InboxFilter.vue";
import  conversationModal  from "./conversationModal.vue";
import  gmailModal  from "./conversation/gmail.vue";
import  OnboardingInbox  from "./OnboardingInbox";
import  CreateTicket  from "./CreateTicket.vue";



export default {
  name: "inbox2",
  mixins: [_is, getPlatformImage],
  components: {
    InboxFilter,
    conversationModal,
    OnboardingInbox,
    CreateTicket,
    gmailModal
  },
  data() {
    return {
      room: {},
      gmailModal,
      conversationModal: conversationModal,
      loading: {
        loadMore: false
      },
      meta: false,
      oldNotes:[],
      selectBulkCheckBox: false,
      func: func,
      pages: [],
      conversationId: '',
      searchQuery: '',
      clickedMessage: {},
      show: {
        menu: false,
        notificationBell: false,
        markAsReadCheckboxes: false
      },
      windowHeight: '',
      skip: 30
    };
  },
  computed: {
    ...mapGetters("session", ["isLoggedIn","getUser","getJwt","getPreferences"]),
    ...mapGetters("loading", ["loadingMessages"]),
    ...mapGetters('notifications', ['getNotificationNotes', 'getNotificationMessages', 'getNotificationMessagesGroupedByPageId']),
    ...mapGetters('inboxFilters', ['getInboxFilters']),
    ...mapGetters("accounts", ["accountsById", "accountsByPId"  , "workspaceAccountsByPId","workspaceAccountsById"]),
    ...mapGetters("messages", ["messages", "getNewMessages", "viewingMessages"]),
    ...mapGetters("statuses", ["statuses", "statusesById", "statusesByName"]),
    ...mapGetters('networks', ['networks', 'networksById', 'networksByName']),    
    ...mapGetters('htmlModals', ['modals']),
    ...mapGetters('workspaces', ['currentWorkspace']),
    ...mapGetters('tags', ['tagsById', 'tagsByTypeName', 'getEnumaratedTags']),
    alltags() {
      return _.orderBy(this.tagsByTypeName['DefaultMessageTag'].concat(this.currentWorkspace.userTags), ['name'],['asc']);
    },
    orderedNotifications() {
      return _.orderBy(this.getNotificationNotes, ['receivedAt'], ['desc']);
    },
    checkAnySelected() {
      return _.filter(this.messages, {selected: true});
    }
  },
  methods: {
    ...mapActions("session", ["setPreferencesInboxView2"]),
    ...mapActions("messages", ["setMessages", "setConcatMessages", "viewingMessagesArray", "setMessagesCount"]),
    ...mapActions("loading", ["setLoadingMessages"]),
    ...mapActions("statuses", ["setStatuses"]),
    ...mapActions('inboxFilters', ['setInboxFilters']),
    ...mapActions("htmlModals", ["setConversationModal", "setConversationModalId", "setTicketModal", "setCreateSearchModal", "setAutomationRulesModal"]),
    ...mapActions("notifications", ["setNoteNotificationSince","setNotificationNotes", "setNotificationMessages", "setNotificationMessagesGroupedByPageId", "setNotificationSince"]),
    setInboxView(status){
      this.setPreferencesInboxView2(status);
      if(status){
        this.$router.push({ "path": "inbox2" })
      }else{
        this.$router.push({ "path": "inbox" })
      }
    },
    renderByPlatform(){
      return this.conversationModal
      if(this.networksById[this.clickedMessage.platform].name == 'Gmail'){
        return this.gmailModal
      }else{
        return this.conversationModal
      }
      
    },
        refresh(){

          this.selectBulkCheckBox = false

          this.setLoadingMessages(true);

          let payload = {
            query: {
              limit: 15,
              workspaceId: this.currentWorkspace._id
            }
          }

          if(this.getInboxFilters.statusId) payload.query.statusId = this.getInboxFilters.statusId

          //IF this.getInboxFilters.pageId == 1  mean is All Accounts selected
          //if(this.getInboxFilters.pageId) payload.query.pageId = this.getInboxFilters.pageId

          if(this.getInboxFilters.pageIds) payload.query.pageId = this.getInboxFilters.pageIds

          if(this.getInboxFilters.tags) payload.query.tagId = this.getInboxFilters.tags

          if(this.getInboxFilters.notTags) payload.query.notTagId = this.getInboxFilters.notTags

          if(this.getInboxFilters.after) payload.query.after = this.getInboxFilters.after

          if(this.getInboxFilters.before) payload.query.before = this.getInboxFilters.before

          if(this.getInboxFilters.assignedTo) payload.query.assigneeId = this.getInboxFilters.assignedTo


        _system.services.messages.get(payload, (err, data) => {
            let messages = _system.services.messages.helper(data);

            messages = _.map(messages, (message) => {

              if(!message.text) message.text = ''
              if(message.reply && !message.reply.text) message.reply.text = ''

              if(this.networksById[message.platform].name == 'Gmail' || this.networksById[message.platform].name == 'Email'){
                message.from.name = _.get(message, 'from.email')
                message.to.name = _.get(message, 'to.email')
                message.text = message.text.slice(0, 200)
                if(message.reply){
                  message.reply.text = message.reply.text.slice(0, 200)
                  message.reply.from.name = _.get(message.reply, 'from.email')
                  message.reply.to.name = _.get(message.reply, 'to.email')
                }
              }

              //Copy comment thread into inbox only for Facebook and Instagram
              if((this.networksById[message.platform].name == 'Facebook' || this.networksById[message.platform].name == 'Instagram') && !this._is(message, 'directMessage')){
                if(message.reply && message._id != message.reply._id){
                  message.thread = {
                    exist: true,
                    loading: true
                  }
                }
              }

              if(this.workspaceAccountsByPId[message.from.id]){
                if(message.to) message.from.name = _.get(message, 'to.name')
                if(message.to) message.from.id = _.get(message, 'to.id')
                if(message.to && message.to.avatar) message.from.avatar = _.get(message, 'to.avatar')
              }
     
              return message
            })

            //console.log(messages)

            this.setMessages(messages);

            //Set empty for notified messages
            this.setNotificationMessages([]);
            this.setNotificationMessagesGroupedByPageId([]);
            this.setNotificationSince(+ new Date());

            //Update desktop app red label PUFF!
              if(window.juphyDesktopApp){
                window.ipcRenderer.send('removePing', data);
              }

            this.setLoadingMessages(false);

                        //Load thread comments for facebook
            for (const message of messages) {
              if(message.thread){
                const index = _.findIndex(this.messages, { _id: message._id });
                api.get("/api/v1/conversations/" + message._id,(err, data) => {
                  if(err) console.log(err.message);


                  if(data.replies && data.replies.length){
                    data.replies = _.map(data.replies, reply => {
                      if(!reply.from){
                        reply.from = {
                          name: 'Unknown'
                        }
                      }
                      return reply;
                    })
                  }

                  //Mark it as a last message in the thread
                  data.replies[data.replies.length-1].last = true;

                  //check if reply is a connected facebook page and fix it!
                  data.replies = _.map(data.replies, (reply) => {
                    if (_.find(this.accountsByPId[reply.from.id])){
                      reply.from.avatar = this.accountsByPId[reply.from.id].avatar
                      return reply;
                    }else{
                      return reply;
                    }
                  });

                  data.replies =  _system.services.messages.helper(data.replies);
                  data.replies =  [message].concat(data.replies);

                  //order By date
                  data.replies = _.orderBy(data.replies, ['createdAt'], ['asc']);
                  
                  data.replies[0].first = true;

                  message.thread.data = data;
                  message.thread.loading = false;
                  console.log(message);
                  this.$set(this.messages, index, message);
                });
              }
            }

          });



        },
        filterUnmatchedTags(message){
            return _.filter(message.tags, tag => this.tagsById[tag]);
        },
        filterTicketTags(message){
          if(message.tags && message.tags.length){
            if(message.tags.indexOf(this.getEnumaratedTags.Ticket._id) !== -1){
              return true
            }else{
              return false
            }
          }else{
            return false
          }           
        },
        filterTicketSolvedTags(message){
          if(message.tags && message.tags.length){
            if(message.tags.indexOf(this.getEnumaratedTags.TicketSolved._id) !== -1){
              return true
            }else{
              return false
            }
          }else{
            return false
          }           
        },
        filterNotesTags(message){
          if(message.notes && message.notes.length){
            return true
          }else{
            return false
          }
        },
        filterReadTags(message){
          if(message.tags && message.tags.length){
            if(message.tags.indexOf(this.getEnumaratedTags.Read._id) !== -1){
              return true
            }else{
              return false
            }
          }else{
            return false
          }
        },
        filterByArchivedTags(message){
          if(message.tags && message.tags.length){
            if(message.tags.indexOf(this.getEnumaratedTags.Archived._id) != -1){
              return true
            }else{
              return false
            }
          }else{
            return false
          }
        },
        //Supabase
        viewingByRender(message){
          //let matched = _.find(window.viewbyMessage, { messageId: message._id });
          let matched = _.find(this.viewingMessages, { messageId: message._id });
          return matched
          //console.log(matched);
        },
        openConversation(e, message){

          //supabase
          window.room.send({
            type: 'broadcast',
            event: 'opened',
            payload: { 
              messageId: message._id,
              date: Date.now(),
              user: this.getUser
             },
          })

           if( navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i) ) return this.$router.push("/inbox?conversation="+ message._id);

           this.clickedMessage = message; 
          
          if(e.metaKey){
            this.$router.push("/inbox?conversation="+ message._id);
          }else{
            this.setConversationModalId(message._id);
            this.setConversationModal(true);
            document.body.classList.add('overflowYHidden');
          }  
        },
         hideComment(_id, platform, type, event, messageParam, parentMessage){
           if(event.srcElement.lastChild.textContent == 'Hiding...') return alert('Be patient! please :)')

          document.getElementById(_id+'hideunhide').textContent = 'Hiding...';


            if(platform == 'Facebook'){
              let payload = {
                _id: _id,
                body: {
                  hidden: true
                }
              };
              _facebook.api.comment.hide(payload, (error, message) => {
                if(error) return alert(error.data.message);

                if(type == "message"){
                  let index = _.findIndex(this.messages, {_id: _id});
                  if(index != -1) this.messages[index].tags = message.tags
                  this.$set(this.messages, index,  this.messages[index]);
                }

                if(type == "reply"){
                  
                  let parentMessageIndex = _.findIndex(this.messages, {_id: parentMessage._id});

                  let messageIndex = _.findIndex(this.messages[parentMessageIndex].thread.data.replies, {_id: messageParam._id});
                  
                  if(messageIndex != -1) this.messages[parentMessageIndex].thread.data.replies[messageIndex].tags = message.tags

                   this.$set(this.messages, parentMessageIndex,  this.messages[parentMessageIndex]);
      
                }


                document.getElementById(_id+'hideunhide').textContent = 'Unhide';

              });
            }
            if(platform == 'Instagram'){
              let payload = {
                _id: _id,
                body: {
                  hidden: true
                }
              };
              _instagram.api.comment.hide(payload, (error, message) => {
                if(error) return alert(error.data.message);

                if(type == "message"){
                  let index = _.findIndex(this.messages, {_id: _id});
                  if(index != -1) this.messages[index].tags = message.tags
                  this.$set(this.messages, index,  this.messages[index]);
                }

                if(type == "reply"){
                  
                  let parentMessageIndex = _.findIndex(this.messages, {_id: parentMessage._id});

                  let messageIndex = _.findIndex(this.messages[parentMessageIndex].thread.data.replies, {_id: messageParam._id});
                  
                  if(messageIndex != -1) this.messages[parentMessageIndex].thread.data.replies[messageIndex].tags = message.tags

                   this.$set(this.messages, parentMessageIndex,  this.messages[parentMessageIndex]);
      
                }

                document.getElementById(_id+'hideunhide').textContent = 'Unhide';

              });
            }
          },
         unhideComment(_id, platform, type, event, messageParam, parentMessage){
           if(event.srcElement.lastChild.textContent == 'Hiding...') return alert('Be patient! please :)')
          document.getElementById(_id+'hideunhide').textContent = 'Unhiding...';
            if(platform == 'Facebook'){
              let payload = {
                _id: _id,
                body: {
                  hidden: true
                }
              };
              _facebook.api.comment.unhide(payload, (error, message) => {
                if(error) return alert(error.data.message);

                if(type == "message"){
                  let index = _.findIndex(this.messages, {_id: _id});
                  if(index != -1) this.messages[index].tags = message.tags
                  this.$set(this.messages, index,  this.messages[index]);
                }

                if(type == "reply"){
                  
                  let parentMessageIndex = _.findIndex(this.messages, {_id: parentMessage._id});

                  let messageIndex = _.findIndex(this.messages[parentMessageIndex].thread.data.replies, {_id: messageParam._id});
                  
                  if(messageIndex != -1) this.messages[parentMessageIndex].thread.data.replies[messageIndex].tags = message.tags

                   this.$set(this.messages, parentMessageIndex,  this.messages[parentMessageIndex]);
      
                }

                  document.getElementById(_id+'hideunhide').textContent = 'Hide';
              });
            }
            if(platform == 'Instagram'){
              let payload = {
                _id: _id,
                body: {
                  hidden: true
                }
              };
              _instagram.api.comment.unhide(payload, (error, message) => {
                if(error) return alert(error.data.message);

                if(type == "message"){
                  let index = _.findIndex(this.messages, {_id: _id});
                  if(index != -1) this.messages[index].tags = message.tags
                  this.$set(this.messages, index,  this.messages[index]);
                }

                if(type == "reply"){
                  
                  let parentMessageIndex = _.findIndex(this.messages, {_id: parentMessage._id});

                  let messageIndex = _.findIndex(this.messages[parentMessageIndex].thread.data.replies, {_id: messageParam._id});
                  
                  if(messageIndex != -1) this.messages[parentMessageIndex].thread.data.replies[messageIndex].tags = message.tags

                   this.$set(this.messages, parentMessageIndex,  this.messages[parentMessageIndex]);
      
                }

                document.getElementById(_id+'hideunhide').textContent = 'Hide';

              });
            }
          },
        search(){
          let filtered = _.map(this.messages, message => {
             var check = new RegExp(this.searchQuery, "ig");
              message.text = message.text.toString().replace(check, function(matchedText,a,b){
                  return ('<strong style="background-color: #faff00;">' + matchedText + '</strong>');
              });

            return message;
          });
          this.setMessages(filtered);
          this.searchQuery = ''
        },
        changeStatus(name, message){
         api.put("/api/v1/messages/" + message._id +"/status", { status: { _id: (name == 'Pending') ? this.statusesByName['Pending']._id : this.statusesByName['Solved']._id } }, (err, data) => {
        if(err) return alert(err.message);

        //update new status on inbox list
          this.messages[_.findIndex(this.messages, function(o){ return o._id == data._id })].status =  this.statusesByName[name]._id;
          this.setMessages(this.messages);
        })          
      },
      loadNotifiedMessages(){

          let newMessages = _.filter(this.messages, message => !_.find(this.getNotificationMessages, { _id: message._id }));

          this.setMessages(newMessages);
          this.setConcatMessages(this.getNotificationMessages)
          
          this.setNotificationMessages([]);
          this.setNotificationMessagesGroupedByPageId([]);
          this.setNotificationSince(+ new Date());
        
      },
      loadNotifiedMessagesByPage(){

          let messages = _.filter(this.messages, message => !_.find(this.getNotificationMessagesGroupedByPageId[this.getInboxFilters.pageId], { id: message.id }));
          this.setMessages(messages);

          this.setConcatMessages(this.getNotificationMessagesGroupedByPageId[this.getInboxFilters.pageId])
          
          //filter by pageId
          let removedNewNotificationMessages = _.filter(this.getNotificationMessages, (notificationMessage) => notificationMessage.page != this.getInboxFilters.pageId)
          this.setNotificationMessages(removedNewNotificationMessages);
          this.setNotificationMessagesGroupedByPageId(removedNewNotificationMessages);

          this.setNotificationSince(+ new Date());
        
      },
      loadMore(){
/*         let is = true
        let skip = 0;
        window.onscroll = () => {
        
          
          if(is && this.windowHeight > 1100 && document.documentElement.scrollTop + window.innerHeight > this.windowHeight - 1100) {
            is = false
            skip += this.messages.length
            let payload = {
              query: {
                skip: skip,
                limit: 20,
                workspaceId: this.currentWorkspace._id,
                statusId: this.statusesByName['Pending']._id
              }
            }

            if(this.getInboxFilters.pageId) payload.query.pageId = this.getInboxFilters.pageId

          _system.services.messages.get(payload, (err, data) => {
            let manipulated = _system.services.messages.helper(data);
            let concatedMessages = this.messages.concat(manipulated);
            this.setMessages(concatedMessages);  
            setTimeout(() => {
              this.windowHeight = document.body.scrollHeight
              (data.length < 20 ) ?  is = false : is = true 
            }, 500)
        
          });

          }

        }; */
    },
    markAsTicketSingle(message){

      if(!message.tags) message.tags = [];

      let tagIndex = message.tags.indexOf(this.getEnumaratedTags.Ticket._id);

      if(tagIndex !== -1){
        message.tags.splice(tagIndex, 1);
      }else{
        message.tags.push(this.getEnumaratedTags.Ticket._id)
      }

      let payload = {
        body: [{
          _id: message._id,
          tags: message.tags
        }]
      }
      _system.services.messages.update(payload, (err, messages) => {
        if(err) return alert(err.message);
        
      });
    },
    markAsArchivedSingle(message){

      if(!message.tags) message.tags = [];

      let tagIndex = message.tags.indexOf(this.getEnumaratedTags.Archived._id);

      if(tagIndex !== -1){
        message.tags.splice(tagIndex, 1);
      }else{
        message.tags.push(this.getEnumaratedTags.Archived._id)
      }

      let payload = {
        body: [{
          _id: message._id,
          tags: message.tags
        }]
      }
      _system.services.messages.update(payload, (err, messages) => {
        if(err) return alert(err.message);
        
      });
    },
    markAsReadSingle(message){

      if(!message.tags) message.tags = [];

      let tagIndex = message.tags.indexOf(this.getEnumaratedTags.Read._id);

      if(tagIndex !== -1){
        message.tags.splice(tagIndex, 1);
      }else{
        message.tags.push(this.getEnumaratedTags.Read._id)
      }

      let payload = {
        body: [{
          _id: message._id,
          tags: message.tags
        }]
      }
      _system.services.messages.update(payload, (err, messages) => {
        if(err) return alert(err.message);
        
      });
    },
    moveToSelectedTag(e){
      let tag = _.find(this.alltags, { _id: e.target.value});
      let selectedMessages = _.chain(this.messages).filter({selected: true}).map( message => {
        if(!message.tags) message.tags = [];
        
        if(message.tags.indexOf(tag._id) == -1){
          message.tags.push(tag._id);
        }

        return _.pick(message, ['_id', 'tags']) 

      }).value()

      let payload = {
        body: selectedMessages
      }

      _system.services.messages.update(payload, (err, messages) => {
        if(err) return alert(err.message);

      iziToast.success({
          position: 'bottomCenter',
          title:  selectedMessages.length +' items tagged as ' + tag.name
      });

        this.refresh();
        
      });
    },
    moveToArchive(){
      let selectedMessages = _.chain(this.messages).filter({selected: true}).map( message => {
        if(!message.tags) message.tags = [];
        
        if(message.tags.indexOf(this.getEnumaratedTags.Read._id) == -1){
          message.tags.push(this.getEnumaratedTags.Read._id);
        }

        if(message.tags.indexOf(this.getEnumaratedTags.Archived._id) == -1){
          message.tags.push(this.getEnumaratedTags.Archived._id);
        }

        return _.pick(message, ['_id', 'tags']) 

      }).value()

      let payload = {
        body: selectedMessages
      }
      _system.services.messages.update(payload, (err, messages) => {
        if(err) return alert(err.message);

      iziToast.success({
          position: 'bottomCenter',
          title:  selectedMessages.length +' items moved to Archive and marked as Read'
      });

        this.refresh();
        
      });
    },
    markAsRead(){
      let selectedMessages = _.chain(this.messages).filter({selected: true}).map( message => {
        if(!message.tags) message.tags = [];

        if(message.tags.indexOf(this.getEnumaratedTags.Read._id) == -1){
          message.tags.push(this.getEnumaratedTags.Read._id);
        }

        return _.pick(message, ['_id', 'tags']) 

      }).value()

      let payload = {
        body: selectedMessages
      }

      _system.services.messages.update(payload, (err, messages) => {
        if(err) return alert(err.message);

      iziToast.success({
          position: 'bottomCenter',
          title:  selectedMessages.length +' items marked as Read'
      });

        this.refresh();
        
      });
    },
    isChecked(message){
      let index = _.findIndex(this.messages, { _id: message._id});
      if(this.messages[index].selected == true) return true
      if(!this.messages[index].selected) return false

/*       let index = _.findIndex(this.messages, { _id: message._id});
      if(message.tags) {
        if(message.tags.indexOf(this.getEnumaratedTags.Read._id) !== -1){
         this.messages[index].selected = true;
         return true;
        }
      }
      return false; */
    },
    renderDate(time){
      var options = { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute:'2-digit' };
      var formattedTime  = new Date(time)

      if(Intl && Intl.DateTimeFormat() && Intl.DateTimeFormat().resolvedOptions() && Intl.DateTimeFormat().resolvedOptions().timeZone){
        options.timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
      }
      return formattedTime.toLocaleDateString("en-US", options)
    },
    selectAll(){
      for (const [index, v] of this.messages.entries()) {
        this.bulkSelection(this.messages[index]);
      }
      if(!this.selectBulkCheckBox){
        this.selectBulkCheckBox = true
      }else{
        this.selectBulkCheckBox = false
      } 
    },
    bulkSelection(message){
      let index = _.findIndex(this.messages, { _id: message._id});
      if(message.selected) {
        this.messages[index].selected = false
      } else {
        this.messages[index].selected = true;
      } 

      this.$set(this.messages, index, this.messages[index]);

    },
    removeFromNotifications(notification){
      this.setNoteNotificationSince(new Date().getTime());
      this.oldNotes.push(notification);
      let notifications = _.reject(this.getNotificationNotes, { 'messageId': notification.messageId});
      this.setNotificationNotes(notifications);
    },
    openNotesNotification(){
      //console.log(this.getNotificationNotes);
      //if(document.getElementById('notificationPopup').style.visibility == 'visible') return

      this.show.notificationBell = true;

      document.getElementById('notificationPopup').style.visibility = "visible";
      document.getElementById('notificationPopup').style.top = "74px";
      document.getElementById('notificationPopup').focus({ preventScroll: true });
    },
    closeNotesNotification(){
      document.getElementById('notificationPopup').blur();
      document.getElementById('notificationPopup').style.visibility = "hidden";
    },
      fetchMoreMessages(){
            this.loading.loadMore = true;
            let payload = {
              query: {
                skip: this.getInboxFilters.skip,
                limit: 15,
                workspaceId: this.currentWorkspace._id
              }
            }


          if(this.getInboxFilters.pageIds) payload.query.pageId = this.getInboxFilters.pageIds

          if(this.getInboxFilters.tags) payload.query.tagId = this.getInboxFilters.tags

          if(this.getInboxFilters.notTags) payload.query.notTagId = this.getInboxFilters.notTags

          if(this.getInboxFilters.after) payload.query.after = this.getInboxFilters.after

          if(this.getInboxFilters.before) payload.query.before = this.getInboxFilters.before

/*           payload.query.beforeId = (this.messages[this.messages.length-1].reply) ? this.messages[this.messages.length-1].reply._id : this.messages[this.messages.length-1]._id */

          if(this.getInboxFilters.assignedTo) payload.query.assigneeId = this.getInboxFilters.assignedTo

          _system.services.messages.get(payload, (err, data) => {

            let manipulated = _system.services.messages.helper(data);

            let concatedMessages = this.messages.concat(manipulated);

            concatedMessages = _.map(concatedMessages, (message) => {

              if(!message.text) message.text = ''
              if(message.reply && !message.reply.text) message.reply.text = ''

              if(this.networksById[message.platform].name == 'Gmail' || this.networksById[message.platform].name == 'Email'){
                message.from.name = _.get(message, 'from.email')
                message.to.name = _.get(message, 'to.email')
                message.text = message.text.slice(0, 200)
                if(message.reply){
                  message.reply.text = message.reply.text.slice(0, 200)
                  message.reply.from.name = _.get(message.reply, 'from.email')
                  message.reply.to.name = _.get(message.reply, 'to.email')
                }
              }

              //Copy comment thread into inbox only for Facebook and Instagram
              if((this.networksById[message.platform].name == 'Facebook' || this.networksById[message.platform].name == 'Instagram') && !this._is(message, 'directMessage')){
                if(message.reply && message._id != message.reply._id){
                  message.thread = {
                    exist: true,
                    loading: true
                  }
                }
              }

              if(this.workspaceAccountsByPId[message.from.id]){
                if(message.to) message.from.name = _.get(message, 'to.name')
                if(message.to) message.from.id = _.get(message, 'to.id')
                if(message.to && message.to.avatar) message.from.avatar = _.get(message, 'to.avatar')
              }
              return message
            })

            if(concatedMessages.length === this.messages.length){
              iziToast.success({
                     title: 'No more messages to display.',
                     position: 'bottomCenter',
                     timeout: 2500,
                     pauseOnHover: false,
               });
            }

            this.setMessages(concatedMessages);  

            this.loading.loadMore = false;


            this.getInboxFilters.skip += 15;


            //Load thread comments for facebook
            for (const message of concatedMessages) {
              if(message.thread){
                const index = _.findIndex(this.messages, { _id: message._id });
                api.get("/api/v1/conversations/" + message._id,(err, data) => {
                  if(err) console.log(err.message);

                  if(data.replies && data.replies.length){
                    data.replies = _.map(data.replies, reply => {
                      if(!reply.from){
                        reply.from = {
                          name: 'Unknown'
                        }
                      }
                      return reply;
                    })
                  }

                  //Mark it as a last message in the thread
                  data.replies[data.replies.length-1].last = true;

                  //check if reply is a connected facebook page and fix it!
                  data.replies = _.map(data.replies, (reply) => {
                    if (_.find(this.accountsByPId[reply.from.id])){
                      reply.from.avatar = this.accountsByPId[reply.from.id].avatar
                      return reply;
                    }else{
                      return reply;
                    }
                  });

                  data.replies =  _system.services.messages.helper(data.replies);
                  data.replies =  [message].concat(data.replies);

                  //order By date
                  data.replies = _.orderBy(data.replies, ['createdAt'], ['asc']);
                  
                  data.replies[0].first = true;

                  message.thread.data = data;
                  message.thread.loading = false;
                  this.$set(this.messages, index, message);
                });
              }
            }
        
          });
    },
    throwImgError(message){
        document.getElementById(message._id+'avatar').src = '/img/avatar.jpg';
    },
    stripHtml(html){
      if(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      }else{
        return ""
      }

},
ratingCalculator(tags, type){
      let rating = 1;
      if(tags.includes(this.getEnumaratedTags.OneStar._id)){
        rating = 1;
      }

      if(tags.includes(this.getEnumaratedTags.TwoStar._id)){
        rating = 2;
      }

      if(tags.includes(this.getEnumaratedTags.ThreeStar._id)){
        rating = 3;
      }

      if(tags.includes(this.getEnumaratedTags.FourStar._id)){
        rating = 4;
      }

      if(tags.includes(this.getEnumaratedTags.FiveStar._id)){
        rating = 5;
      }
      
      let array1 = [];
      let i;
      for(i = 0; i < 5; i++){
        let obj = {};
        obj.id = i;
        if(i < rating){
          obj.rated = 'orange'
        }else{
          obj.rated = ''
        }
        array1.push(obj)
      }

      return array1;

    }

  },
  mounted(){

    AOS.init();
   

    const notificationPopup = document.getElementById('notificationPopup');

      notificationPopup.addEventListener('focusout', (event) => {
        event.target.style.visibility = "hidden";
        this.show.notificationBell = false;
      });

  $('.ui.star.rating').rating('disable');


  window.supabase.channel(this.currentWorkspace._id).on('broadcast', { event: 'closed' }, (data) => { 
    if(data.payload.messageId){
      this.viewingMessagesArray({
        type: 'delete',
        data: data.payload
      })
    }else{
      this.viewingMessagesArray({
        type: 'deleteByUserId',
        data: data.payload
      }) 
    }
  })

  console.log('open conversation in mounted inbox2')
  setTimeout(() => {
    if(this.$route.query.conversation) this.openConversation({}, { _id: this.$route.query.conversation });
  }, 1500);

  },
  destroyed(){
    window.onscroll = null;
    this.setNotificationNotes([]);
  },
  created() {

    if(!this.getPreferences.inboxView2){
      if(this.$route.query.conversation) {
        return this.$router.push({ "path": "inbox?conversation=" + this.$route.query.conversation })
      }else{
        return this.$router.push({ "path": "inbox" })
      }
    }

    console.log('inbox2');
    //this.getInboxFilters.skip = 15;
    
    if(this.$route.query.state && this.$route.query.state.group) return this.$router.push({ "path": "accounts/facebook" });

    this.getInboxFilters.tags = _.remove(this.getInboxFilters.tags, (n)=> n !== this.getEnumaratedTags.Archived._id);
    this.getInboxFilters.notTags.push(this.getEnumaratedTags.Archived._id);
    this.setInboxFilters(Object.assign({}, this.getInboxFilters ));

    AOS.init({
      once: true, // whether animation should happen only once - while scrolling down
    });
    
  }
};
</script>

<template>

<!-- <component :is="conversationModal" v-if="modals.conversation" :conversationId="modals.conversationId"></component> -->

<div style="height:100%; margin-bottom: -1rem;">

<OnboardingInbox v-if="modals.onboardingInbox" data-aos="fade-in"></OnboardingInbox>

<CreateTicket v-if="modals.createTicket"></CreateTicket>

<component :is="renderByPlatform()" v-if="modals.conversation" :openedMessage="clickedMessage" :conversationId="modals.conversationId"></component>

<div style="height:100%;" class="ui stackable grid">

<div style="background: #f9f9f9; padding:0; position: relative;margin-bottom: -1rem;" class="twelve wide column">


<div style="background: rgb(242, 242, 242, 0.97) none repeat scroll 0% 0%; position:relative; z-index:999" class="ui padded grid topBar">
  <div class="nine wide column">

  <div v-if="show.markAsReadCheckboxes" class="ui checkbox">
    <input @click="selectAll()" type="checkbox" :checked="selectBulkCheckBox">
    <label></label>
  </div>

  <button style="background: transparent;margin:0;" v-if="!show.markAsReadCheckboxes" @click="show.markAsReadCheckboxes = true"  class="ui icon  circular button" > <i class="tasks icon"></i></button>
  <button title="Mark as Read" v-if="show.markAsReadCheckboxes" :disabled="!checkAnySelected.length" @click="markAsRead()" class="ui  circular icon button" ><i class="envelope open icon"></i> </button>
  <button title="Mark as Read + Archived" v-if="show.markAsReadCheckboxes" :disabled="!checkAnySelected.length" @click="moveToArchive()" class="ui  circular icon button" ><i class="archive icon"></i> </button>
  <button style="background: transparent;" v-if="show.markAsReadCheckboxes" @click="show.markAsReadCheckboxes = false" class="ui  circular icon button" ><i class="chevron left icon"></i></button>

  <div  v-if="show.markAsReadCheckboxes"  class="ui action input">
    <select style="border-radius: 2rem;" :class="'ui icon selection dropdown'" name="pets" @change="moveToSelectedTag($event)" id="pet-select">
    <option value="" selected disabled hidden>Choose tag</option>
    <option v-for="(tag, i) in alltags" :key="i" :value="tag._id" >
        {{tag.name}}
    </option>
  </select>
</div>

  <div style="height: 22px; border-left: 1px solid #e5e5e5; display: inline-block; vertical-align: middle;"></div>

  <button style="background: transparent; margin:0;" @click="refresh()" :class="(loadingMessages) ? 'loading' : ''" class="ui icon  circular button" > <i class="sync alternate icon"></i></button>
  </div>
  <div style="text-align: right;" class="seven wide column">
 
  <button v-if="getUser.email == 'erdi@juphy.com' || getUser.email == 'eyup@juphy.com' || currentWorkspace.name == 'ELC'" @click="setTicketModal(true)" class="ui circular green button">Create Ticket</button>

  <button href="#" class="ui small circular icon button" @click="setCreateSearchModal(true)"  :disabled="loadingMessages">
    <i class="icon search"></i>
  </button>

  <button @click="setInboxView(true)" class="ui icon circular button" :class="(getPreferences.inboxView2) ? ' active':''" data-inverted="" data-tooltip="Threaded comments view (new)" data-position="bottom center"><i class="comments icon"></i></button>

  <button @click="setInboxView(false)" class="ui icon circular button" :class="(!getPreferences.inboxView2) ? ' active':''" data-inverted="" data-tooltip="Non-threaded comments view (classic)" data-position="bottom center"><i class="comment icon"></i></button>

  </div>
</div>

<div class="inbox" style="position: absolute; left:0; top:0px; bottom: 0px; right:0; overflow-x: hidden; height: 100vh; min-height: 100%;">

<div style="height: 61.43px;"></div>



<div id="notificationPopup" tabindex="-1" style=" margin: -1rem -1rem 1rem -1rem; position:absolute; right: 10rem; left: 10rem; z-index:9; background: rgba(243,243,243,0.95); border-top: 1px solid #eeeeee; box-shadow: 2px 2px 2px rgba(0,0,0,0.15); padding-bottom:0; border-radius: 0 0 7px 7px;" class="ui basic segment">
<p v-if="!getNotificationNotes.length" style="text-align:center; color: #b5b5b5;">No new message from team.</p>
<div v-if="getNotificationNotes.length" class="ui selection divided list">
  <div v-for="(notification, index) in orderedNotifications" :key="index" @click="openConversation($event, { _id: notification.messageId }); removeFromNotifications(notification);" class="item">
    <img class="ui avatar image" style="vertical-align: bottom;" :src="'/img/avatar/roboto/128/latin_'+ func.turkishToEnglish(notification.user.email).charAt(0).toLowerCase() + '.png'">
    <div class="content">
      <b class="header">{{notification.user.email}}</b>
      <div v-if="notification.type == 'note'" class="description"> <i class="comment alternate icon"></i> {{notification.text.substring(0,40)}}... <b style="color: #3960BD;">open</b> </div>
      <div v-if="notification.type == 'assign'" class="description"> <b><i class="user plus icon"></i> Assigned a ticket for you!</b> <b style="color: #3960BD;">open</b> </div>
    </div>
  </div>
  </div>
<div v-if="oldNotes.length"  class="ui divider"></div>
  <!-- Old Notifications -->
<div v-if="oldNotes.length" class="ui selection list">
  <div v-for="(notification, index) in oldNotes" :key="index" @click="openConversation($event, { _id: notification.messageId });" :style="{'opacity':'0.2'}" class="item">
    <img class="ui avatar image" style="vertical-align: bottom;" :src="'/img/avatar/roboto/128/latin_'+ func.turkishToEnglish(notification.user.email).charAt(0).toLowerCase() + '.png'">
    <div class="content">
      <b class="header">{{notification.user.email}}</b>
      <div v-if="notification.type == 'note'" class="description">{{notification.text.substring(0,40)}}... <b>Opened</b> </div>
      <div v-if="notification.type == 'assign'" class="description">Assigned a ticket for you! <b>Opened</b> </div>
    </div>
  </div>
</div>

<div @click="closeNotesNotification();" style="width: 100%; text-align: center;">
  <div class="closeNotification" style="padding: 0px 15px; display: inline-block; background: #eee; border-radius: 5px 5px 0 0;">
    <i class="chevron up icon"></i>
  </div>
</div>
</div>

<div v-if="loadingMessages" data-aos="zoom-in" style="height:100%;" class="ui grid centered stackable">
    <div class="six wide computer sixteen wide mobile column">
        <div class="ui basic segment center aligned">
        <div style="padding:0; color: #333;" class="ui basic segment">
        </div>
        <div class="loader-inner ball-beat"><div></div><div></div><div></div></div>
     
        </div>
    </div>
</div>

<div v-if="!messages.length && !loadingMessages" data-aos="zoom-in" style="height:100%;" class="ui grid centered  stackable">
  <div  class="six wide computer sixteen wide mobile column">
    <div style="margin-top: 150px;" class="ui basic segment center aligned">
      <i style="color: #ddd;" class="inbox huge icon"></i>
      <p style="color: #ddd;">Inbox Zero <i class="checkmark icon"></i></p>
    </div>
  </div>
</div>


<div style="margin-top: 0;" class="ui basic segment">


 <!--  loadNotifiedMessages();  -->
  <div v-if="getNotificationMessages.length && this.getInboxFilters._type == 'all'" data-aos="fade-down" @click="refresh();" style="background: #FFF3A5; cursor:pointer;" class="ui small message ringo">
    <p style="text-align: center; color: #CE9D65;"> <i class="bell icon"></i>See ({{getNotificationMessages.length}}) new messages </p>
  </div>

<!--   <div v-if="getNotificationMessagesGroupedByPageId[this.getInboxFilters.pageId] && this.getInboxFilters._type == 'page'" data-aos="fade-down" @click="loadNotifiedMessagesByPage();" style="background: #FFF3A5; cursor:pointer;" class="ui small message ringo">
    <p style="text-align: center; color: #CE9D65;"> <i class="bell icon"></i>See ({{getNotificationMessagesGroupedByPageId[this.getInboxFilters.pageId].length}}) new messages </p>
  </div> -->



<div style="padding:0; transition: .5s;" v-for="message in messages" :key="message._id" v-show="message.from && !loadingMessages && messages.length"  :class="(show.markAsReadCheckboxes) ? 'bulkCheckSegment' : ''" class="ui basic segment">
  <div v-if="!message.thread" @click="openConversation($event, message)" :style="( (message.reply && message.reply._id && message.reply.from.id != message.from.id) || filterReadTags(message)) ? 'background: #eeeeee;' : ''" class="ui feed main">
  <div :style="(_is(message, 'hidden') || _is(message, 'deleted') ? 'opacity:0.3;' : '')"  class="event">
    <div v-on:click.stop style="transition: .5s;" :style="(show.markAsReadCheckboxes) ? 'width: 40px; display: inline-block;':'width:0px;'" >
      <div v-if="show.markAsReadCheckboxes" class="ui checkbox">
        <input @click="bulkSelection(message)" type="checkbox" :checked="isChecked(message)">
        <label></label>
      </div>
    </div>
    <div style="position: relative;" class="label">
      <img :id="message._id+'avatar'" :src="func.replaceImg(message.from.avatar)" @error="throwImgError(message)">
      <img :src="getPlatformImage(message.platform, message)" style="top:26px; left:-26px; width: 24px;height: 24px;font-size: 0.8em;border: 1px solid rgb(249, 249, 249);position: absolute;" alt="">
    </div>
                <div style="margin-top: 0; word-wrap: anywhere;" class="content">
                  <div class="summary">
                    <a>{{message.from.name}}</a>

                    <div class="date" :title="func.since((message.reply) ? message.reply.createdAt : message.createdAt) + ' ago'">
                      {{renderDate((message.reply) ? message.reply.createdAt : message.createdAt)}} 
                    </div>
                     <span v-if="workspaceAccountsById[message.page]" style="margin-left: 0.5em;font-weight: 400;font-size: .85714286em;padding-right: 5px;border-radius: 25px 7px 7px 25px;padding-top: 2px;padding-bottom: 3px;color: #aaa;">  <img style="width:15px; opacity: 0.5; box-shadow: 1px 1px 2px #ddd; height:15px;margin-right:2px; border-radius:5px;vertical-align: middle;" :src="(workspaceAccountsById[message.page] && workspaceAccountsById[message.page].avatar) ? workspaceAccountsById[message.page].avatar : '/img/avatar.jpg'"> {{workspaceAccountsById[message.page].name}}
                      </span>
                    
                    <div v-on:click.stop style="float: right;" class="date">

                      <a v-if="viewingByRender(message)" style="margin-right: 1rem;" data-aos="zoom-in" class="ui tiny teal image label pulseMe">
                        <img :src="'https://www.gravatar.com/avatar/' + func.md5(viewingByRender(message).user.email) + '?d=monsterid'">
                        {{viewingByRender(message).user.name}}
                        <div class="detail">Viewing</div>
                      </a>

                      <i v-if="filterTicketSolvedTags(message)" style="color: #00B5AD;" title="Ticket Solved" class="check icon"></i>
                      <i v-if="filterNotesTags(message)" style="color: #777;" title="Team Talking About" class="comments outline icon"></i>
                      <i v-if="filterReadTags(message)" style="color: #777;" title="Read" class="envelope open outline icon"></i>
                      <i v-if="filterByArchivedTags(message)" style="color: #777;" title="Marked as Archived" class="archive icon"></i>
                      <i v-if="filterTicketTags(message)" @click="markAsTicketSingle(message)" style="color: #777;" title="Marked as Ticket" class="flag outline icon"></i>

                    </div>
                  </div>
                  <div style="color: #666;" :style="{ opacity: ((_is(message, 'deleted') && !message.reply || message.reply && _is(message.reply, 'deleted')) || (_is(message, 'hidden') && !message.reply || message.reply && _is(message.reply, 'hidden'))) ? '.5' : '1' }" class="extra text">

                    
                  <b v-if="message.reply && message.reply.from && message.from.id != message.reply.from.id" style="vertical-align: middle; color: #333333; text-decoration: underline; font-size: 13px;padding: 2px 2px;border-radius: 3px;"> {{(message.reply && message.reply.from && message.from.id != message.reply.from.id ) ? message.reply.from.name + ':' : 'unknown'}}</b>
                    
<!--                   <b v-if="message.reply && message.reply.from && message.from.id == workspaceAccountsByPId[message.from.id].id" style="vertical-align: middle; color: #333333; text-decoration: underline; font-size: 13px;padding: 2px 2px;border-radius: 3px;"> {{(message.reply && message.reply.from && message.from.id != message.reply.from.id ) ? message.reply.from.name + ':' : 'unknown'}}</b> -->

              
                  <!-- Privaltely replied messages  -->
<!--                   <b v-if="message.reply && message.reply.from && message.from.id == message.reply.from.id && workspaceAccountsByPId[message.reply.from.id] && message.reply.from.id == workspaceAccountsByPId[message.reply.from.id].id" style="vertical-align: middle; color: #333333; text-decoration: underline; font-size: 13px;padding: 2px 2px;border-radius: 3px;"> {{(message.reply && message.reply.from && message.from.id == message.reply.from.id ) ? message.reply.from.name + ':' : 'unknown'}}</b> -->

                <!--   only for the google my business   -->
                  <b v-if="message.reply && message.reply.from && networksById[message.platform].name == 'Google My Business' && message.from.name != message.reply.from.name" style="vertical-align: middle; color: #333333; text-decoration: underline; font-size: 13px;padding: 2px 2px;border-radius: 3px;"> {{(message.reply && message.reply.from && message.from.name != message.reply.from.name ) ? message.reply.from.name + ':' : 'unknown'}}</b>



<span style="vertical-align: middle;">

{{(message.reply) ? stripHtml(message.reply.text) : stripHtml(message.text)}}
</span>

<div v-if="_is(message, 'review')" style="display: block;" class="iconGroup">
  <i v-for="star in ratingCalculator(message.tags)" :key="star.id" :class="'ui small fitted '+ star.rated +' star icon'"></i>
</div>

                  <div style="display: block; vertical-align: top;" v-if="_is(message, 'deleted')" class="meta">
                    <span style="padding-left: 4px;" class="ui red mini label">Deleted</span>
                  </div>
                  <div style="display: block; vertical-align: top;"  v-if="_is(message, 'hidden')" class="meta">
                    <span style="padding-left: 4px;" class="ui black mini label">Hidden</span>
                  </div>
                  </div>

                   <div v-if="message._id == message.reply._id && message.attachments && message.attachments.length &&  networksById[message.platform].name != 'Twitter'" class="extra images">
                      <a v-for="(attachment, index) in message.attachments" :key="`attachment-${index}`" target="_blank" :href="attachment.src"> 
                        
                       <span v-if="attachment.format && attachment.format == 'video'">
                          <video  width="200" controls>
                            <source :src="attachment.src" type="video/mp4">
                            <source :src="attachment.src" type="video/ogg">
                          </video>
                        </span>

                        <span v-if="attachment.format && attachment.format == 'image'">
                            <img style="background: #fff;padding: 3px;border: 1px solid #eee;border-radius: 2px;" :src="attachment.src">
                        </span>

                        <span v-if="attachment.format && attachment.format == 'url'">
                          <a target="_blank" :href="attachment.src">{{attachment.src}}</a>
                        </span>

                        <span v-if="!attachment.format">
                            <img style="background: #fff;padding: 3px;border: 1px solid #eee;border-radius: 2px;" :src="attachment.src">
                        </span>



                        </a>
                    </div>
                   <div v-if="message._id !== message.reply._id && message.reply && message.reply.attachments && message.reply.attachments.length && networksById[message.platform].name != 'Twitter' " class="extra images">
                      <a v-for="(attachment, index) in message.reply.attachments" :key="`attachment-${index}`" target="_blank" :href="attachment.src">
                        
                        
                        <span v-if="attachment.format && attachment.format == 'video'">
                          <video  width="200" controls>
                            <source :src="attachment.src" type="video/mp4">
                            <source :src="attachment.src" type="video/ogg">
                          </video>
                        </span>

                        <span v-if="attachment.format && attachment.format == 'image'">
                            <img style="background: #fff;padding: 3px;border: 1px solid #eee;border-radius: 2px;" :src="attachment.src">
                        </span>

                        <span v-if="attachment.format && attachment.format == 'url'">
                          <a target="_blank" :href="attachment.src">{{attachment.src}}</a>
                        </span>

                        <span v-if="!attachment.format">
                            <img style="background: #fff;padding: 3px;border: 1px solid #eee;border-radius: 2px;" :src="attachment.src">
                        </span>

                         </a>
                    </div>
                    <div v-on:click.stop id="miniAction" class="meta miniActions">
                      <a @click="openConversation($event, message)" class="reply"><i class="reply icon"></i>Reply</a>
                      <!-- <a class="reply"> <i class="hide icon"></i>Hide</a> -->
                      
                      <a v-if="(message.reply._id == message._id) && !_is(message, 'hidden') && (networksById[message.platform].name == 'Facebook' || networksById[message.platform].name == 'Instagram')" @click="hideComment(message._id, networksById[message.platform].name, 'message', $event, message)" class="reply"><i class="hide icon"></i> <span v-bind:id="message._id+'hideunhide'">Hide</span></a>

                      <a v-if="(message.reply._id == message._id) && _is(message, 'hidden') && (networksById[message.platform].name == 'Facebook' || networksById[message.platform].name == 'Instagram')" @click="unhideComment(message._id, networksById[message.platform].name, 'message', $event, message)" class="reply"><i class="unhide icon"></i> <span v-bind:id="message._id+'hideunhide'">Unhide</span> </a>

                      <a v-if="!filterByArchivedTags(message)" @click="markAsArchivedSingle(message)" class="reply"><i class="archive icon"></i>Move to Archive</a>
                      <a v-if="filterByArchivedTags(message)" @click="markAsArchivedSingle(message)" class="reply"><i class="undo alternate icon"></i>Undo Archive</a>
                    </div>
                </div>
              </div>


              </div>

              <div v-if="message.thread" style="min-height: 100px;">
              <div v-if="message.thread.loading" style="position: absolute; top:0; right:0; bottom:0; left:0;" class="ui basic segment loading"></div>

              <div v-if="!message.thread.loading" class="ui feed main">

                <div v-for="reply in message.thread.data.replies" @click="openConversation($event, message)" :key="reply._id" :id="reply._id" :style="(_is(reply, 'hidden') || _is(reply, 'deleted') ? 'opacity:0.3;' : '')" class="event">

                  <div v-if="reply.first" v-on:click.stop style="transition: .5s;" :style="(show.markAsReadCheckboxes) ? 'width: 40px; display: inline-block;':'width:0px;'" >
                    <div v-if="show.markAsReadCheckboxes" class="ui checkbox">
                      <input @click="bulkSelection(message)" type="checkbox" :checked="isChecked(message)">
                      <label></label>
                    </div>
                  </div>
                  <div v-if="!reply.first" v-on:click.stop style="transition: .5s;" :style="(show.markAsReadCheckboxes) ? 'min-width: 40px; display: inline-block;' : 'width:0px;'" >
                  </div>

                  <div style="position: relative;" class="label">
                    <img :id="reply._id+'avatar'" :src="func.replaceImg(reply.from.avatar)" @error="throwImgError(reply)">
                    <img v-if="reply.first" :src="getPlatformImage(reply.platform, reply)" style="top:26px; left:-26px; width: 24px;height: 24px;font-size: 0.8em;border: 1px solid rgb(249, 249, 249);position: absolute;" alt="">
                  </div>
                  <div style="margin-top:0; margin-bottom: 1rem;" class="content">
                    <div class="summary">
                      <a>{{reply.from.name}}</a>
                    <div class="date">
                      {{func.since(reply.createdAt)}} ago on 
                    </div>
                     <span v-if="workspaceAccountsById[message.page]" style="margin-left: 1px;font-weight: 400;font-size: .85714286em;padding-right: 5px;border-radius: 25px 7px 7px 25px;padding-top: 2px;padding-bottom: 3px;color: #aaa;">  <img style="width:15px; opacity: 0.5; box-shadow: 1px 1px 2px #ddd; height:15px;margin-right:2px; border-radius:5px;vertical-align: middle;" :src="(workspaceAccountsById[message.page] && workspaceAccountsById[message.page].avatar) ? workspaceAccountsById[message.page].avatar : '/img/avatar.jpg'"> {{workspaceAccountsById[message.page].name}}
                      </span>
                      <div v-if="reply.first" v-on:click.stop style="float: right;" class="date">
                        
                        <a v-if="viewingByRender(message)" style="margin-right: 1rem;" data-aos="zoom-in" class="ui tiny teal image label pulseMe">
                        <img :src="'https://www.gravatar.com/avatar/' + func.md5(viewingByRender(message).user.email) + '?d=monsterid'">
                        {{viewingByRender(message).user.name}}
                        <div class="detail">Viewing</div>
                      </a>

                      <i v-if="filterTicketSolvedTags(message)" style="color: #00B5AD;" title="Ticket Solved" class="check icon"></i>
                      <i v-if="filterNotesTags(message)" style="color: #777;" title="Team Talking About" class="comments outline icon"></i>
                      <i v-if="filterReadTags(message)" style="color: #777;" title="Read" class="envelope open outline icon"></i>
                      <i v-if="filterByArchivedTags(message)" style="color: #777;" title="Marked as Archived" class="archive icon"></i>
                      <i v-if="filterTicketTags(message)" @click="markAsTicketSingle(message)" style="color: #777;" title="Marked as Ticket" class="flag outline icon"></i>

                    </div>
                    </div>
                    <div class="extra text">
                      {{reply.text}}


                  <div style="display: block; vertical-align: top;" v-if="_is(reply, 'deleted')" class="meta">
                    <span style="padding-left: 4px;" class="ui red mini label">Deleted</span>
                  </div>
                  <div style="display: block; vertical-align: top;"  v-if="_is(reply, 'hidden')" class="meta">
                    <span style="padding-left: 4px;" class="ui black mini label">Hidden</span>
                  </div>

                    </div>
                    <div v-on:click.stop id="miniAction" class="meta miniActions">
                      <a @click="openConversation($event, message)" class="reply">
                        <i class="reply icon"></i> Reply
                      </a>

                      <a v-if="!_is(reply, 'hidden') && (networksById[reply.platform].name == 'Facebook')" @click="hideComment(reply._id, networksById[reply.platform].name, 'reply', $event, reply, message)" class="reply"><i class="hide icon"></i> <span v-bind:id="reply._id+'hideunhide'">Hide</span></a>

                      <a v-if="_is(reply, 'hidden') && (networksById[reply.platform].name == 'Facebook')" @click="unhideComment(reply._id, networksById[reply.platform].name, 'reply', $event, reply, message)" class="reply"><i class="unhide icon"></i> <span v-bind:id="reply._id+'hideunhide'">Unhide</span> </a>

                      <a v-if="reply.last && !filterByArchivedTags(message)" @click="markAsArchivedSingle(message)" class="reply"><i class="archive icon"></i>Move thread to Archive</a>
                      <a v-if="reply.last && filterByArchivedTags(message)" @click="markAsArchivedSingle(message)" class="reply"><i class="undo alternate icon"></i>Undo Archive</a>

                    </div>
                  </div>
                </div>
               
              </div>
              </div>

              </div>
              <div v-if="messages.length > 4 && !loadingMessages" class="ui basic segment center aligned">
                <a @click="fetchMoreMessages()" style="background: transparent; color: #bbb;" :class="{ 'loading' : (loading.loadMore) ? true : false  }" class="ui big icon fluid button">Load More <i class="angle down icon"></i></a>
              </div>
              </div>
			  </div>
			  </div>
				<InboxFilter threaded="true"></InboxFilter>
              </div>
              </div>
</template>

<style scoped>

.topBar .ui.checkbox {
  vertical-align: sub;
  max-width: 17px;
  max-height: 17px;
  margin: 0rem 1rem 0rem 0.5rem;
}
.ui.feed .ui.checkbox {
  vertical-align: sub;
  max-width: 17px;
  max-height: 17px;
  margin: 1.4rem 1.5rem 0rem 0.67rem;
}

.bulkCheckSegment{
  transition: .5s;
  margin-left: -1rem !important;
  border-radius: 0px 5px 5px 0px !important;
}

.bulkCheckSegment .ui.feed{
  transition: .5s;
  border-radius: 0px 5px 5px 0px !important;
}

.ui.feed > .event > .content .extra {
    margin: .5em 0 0;
}

.ui.feed > .event > .content .meta{
  margin: .7em 0 0;
}

.miniActions{
position: relative;
}

.inbox.huge.icon {
  overflow-y: hidden;
}

.inbox {
    overflow-y: scroll;
}
.inbox:hover {
    overflow-y: scroll;
    overflow-y: overlay;
}

:focus {
  outline-style:none;
  box-shadow:none;
  border-color:transparent;
}

#filterButton {
  color: #aaa;
}
#filterButton:hover {
  color: #555;
}

#notificationPopup{
  visibility: hidden;
  top: -295px;
}

.closeNotification{
  color:#cccccc; 
}

.closeNotification:hover{
  color:#333333; 
  cursor: pointer;
  background: #ddd !important;
}

.searchBar{
  margin-left: 10px;
  transition: 0.5s;
}
.searchBar:hover{
   cursor: pointer;
   transition: 0.5s;
   min-width:250px !important;
}
.labelToButton {
  display: block; position: absolute; right: -2px; top:0; height: 14px; width:14px; text-align: center; font-weight: bold; color: #fbfbfb; background: #ff0000; border-radius:18px; font-size:8px;
}
.inboxStatus:hover{
  background: #eeeeee;
}
.ui.feed > .event > .content .extra.images img {
    width: auto;
    max-width: 10em;
}
.ui.feed.main {
  transition: 0.2s ease-out;
  padding: 10px 10px 5px 10px;
  border: 1px solid #f1f1f1;
  border-radius: 5px;
  background: #fff;
}

.ui.feed.main:hover {
 /*  background: #f9fbff; */
  cursor: pointer;
  border-radius: 5px;
  border: 1px solid #e9e9e9;
/* box-shadow: 2px 2px 2px #eee; */
}

/* .ui.feed.main:hover .miniActions{

} */

#miniAction {
  opacity: .4;
}

.ui.feed.main:hover  #miniAction {
  opacity: 1 !important;
}


.ui.feed > .event > .label + .content {
  margin: 0.5em 0 0.35714286em 0;
}

.ui.label .detail {
  background: rgba(0, 0, 0, 0.1);
  margin: -0.5833em -0.833em -0.5833em 0.5em;
  padding: 0.5833em 0.833em;
  border-radius: 0 0.28571429rem 0.28571429rem 0;
}

.ui.feed > .event {
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 0em;
  margin: 0em;
  background: none;
  border-top: none;
}

.ui.feed > .event > .label {
  margin-left: 1.6em;
}

.ui.feed > .event .label {
  border-left: 3px solid #dddddd;
}

.ui.feed > .event > .label {
  display: block;
  flex: 0 0 auto;
  width: 3em;
  height: auto;
  align-self: stretch;
  text-align: left;
}

.ui.feed > .event > .label > img,
.ui.feed > .event > .label > .icon {
  background-color:#eeeeee;
  border-radius: 500rem;
  color: #ffffff;
  width: 3rem;
  height: 3rem;
  line-height: 1.5;
  left: -1.6rem;
  opacity: 1;
  position: relative;
}

.ui.feed > .event > .label img {
  width: 100%;
  height: auto;
  border-radius: 500rem;
}

.ui.feed > .event > .content .extra.text {
  max-width: none;
}

.ui.feed > .event:last-child .label {
  border-left-color: transparent;
}

.ui.opened_message.menu .item::before {
  background: #f0f0f0;
}

.ui.image.label.pulseMe {
  width: auto !important;
  margin-top: 0;
  margin-bottom: 0;
  max-width: 9999px;
  vertical-align: baseline;
  text-transform: none;
  background: #f0f0f0;
  background-color: rgb(240, 240, 240);
  background-image: none;
  padding: .5833em .833em .5833em .5em !important;
  border-radius: .28571429rem;
  -webkit-box-shadow: none;
  box-shadow: none;
  border: 0;
}
.ui.image.label.pulseMe img {
  margin: -.5833em .5em -.5833em -.5em;
  vertical-align: top;
}

.ringo .bell{
  -webkit-animation: ring 6s .1s ease-in-out infinite;
  -webkit-transform-origin: 50% 4px;
  -moz-animation: ring 6s .1s ease-in-out infinite;
  -moz-transform-origin: 50% 7px;
  animation: ring 7s .1s ease-in-out infinite;
  transform-origin: 50% 7px;
}

@-webkit-keyframes ring {
  0% { -webkit-transform: rotateZ(0); }
  1% { -webkit-transform: rotateZ(30deg); }
  3% { -webkit-transform: rotateZ(-28deg); }
  5% { -webkit-transform: rotateZ(34deg); }
  7% { -webkit-transform: rotateZ(-32deg); }
  9% { -webkit-transform: rotateZ(30deg); }
  11% { -webkit-transform: rotateZ(-28deg); }
  13% { -webkit-transform: rotateZ(26deg); }
  15% { -webkit-transform: rotateZ(-24deg); }
  17% { -webkit-transform: rotateZ(22deg); }
  19% { -webkit-transform: rotateZ(-20deg); }
  21% { -webkit-transform: rotateZ(18deg); }
  23% { -webkit-transform: rotateZ(-16deg); }
  25% { -webkit-transform: rotateZ(14deg); }
  27% { -webkit-transform: rotateZ(-12deg); }
  29% { -webkit-transform: rotateZ(10deg); }
  31% { -webkit-transform: rotateZ(-8deg); }
  33% { -webkit-transform: rotateZ(6deg); }
  35% { -webkit-transform: rotateZ(-4deg); }
  37% { -webkit-transform: rotateZ(2deg); }
  39% { -webkit-transform: rotateZ(-1deg); }
  41% { -webkit-transform: rotateZ(1deg); }

  43% { -webkit-transform: rotateZ(0); }
  100% { -webkit-transform: rotateZ(0); }
}

@-moz-keyframes ring {
  0% { -moz-transform: rotate(0); }
  1% { -moz-transform: rotate(30deg); }
  3% { -moz-transform: rotate(-28deg); }
  5% { -moz-transform: rotate(34deg); }
  7% { -moz-transform: rotate(-32deg); }
  9% { -moz-transform: rotate(30deg); }
  11% { -moz-transform: rotate(-28deg); }
  13% { -moz-transform: rotate(26deg); }
  15% { -moz-transform: rotate(-24deg); }
  17% { -moz-transform: rotate(22deg); }
  19% { -moz-transform: rotate(-20deg); }
  21% { -moz-transform: rotate(18deg); }
  23% { -moz-transform: rotate(-16deg); }
  25% { -moz-transform: rotate(14deg); }
  27% { -moz-transform: rotate(-12deg); }
  29% { -moz-transform: rotate(10deg); }
  31% { -moz-transform: rotate(-8deg); }
  33% { -moz-transform: rotate(6deg); }
  35% { -moz-transform: rotate(-4deg); }
  37% { -moz-transform: rotate(2deg); }
  39% { -moz-transform: rotate(-1deg); }
  41% { -moz-transform: rotate(1deg); }

  43% { -moz-transform: rotate(0); }
  100% { -moz-transform: rotate(0); }
}

@keyframes ring {
  0% { transform: rotate(0); }
  1% { transform: rotate(30deg); }
  3% { transform: rotate(-28deg); }
  5% { transform: rotate(34deg); }
  7% { transform: rotate(-32deg); }
  9% { transform: rotate(30deg); }
  11% { transform: rotate(-28deg); }
  13% { transform: rotate(26deg); }
  15% { transform: rotate(-24deg); }
  17% { transform: rotate(22deg); }
  19% { transform: rotate(-20deg); }
  21% { transform: rotate(18deg); }
  23% { transform: rotate(-16deg); }
  25% { transform: rotate(14deg); }
  27% { transform: rotate(-12deg); }
  29% { transform: rotate(10deg); }
  31% { transform: rotate(-8deg); }
  33% { transform: rotate(6deg); }
  35% { transform: rotate(-4deg); }
  37% { transform: rotate(2deg); }
  39% { transform: rotate(-1deg); }
  41% { transform: rotate(1deg); }

  43% { transform: rotate(0); }
  100% { transform: rotate(0); }
}


.pulseMe {
  background: #d1ffd1;
  color: #5abf5a;
  transition: 0.5s;
  -webkit-animation: pulse 1.8s infinite;
  animation: pulse 1.8s infinite;
}


@-webkit-keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(31, 35, 32, 0.5);
  }
  65% {
    box-shadow: 0 0 0 7px rgba(249, 115, 82, 0);
  }
  to {
    box-shadow: 0 0 0 0 rgba(249, 115, 82, 0);
  }
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(31, 35, 32, 0.5);
  }
  65% {
    box-shadow: 0 0 0 7px rgba(249, 115, 82, 0);
  }
  to {
    box-shadow: 0 0 0 0 rgba(249, 115, 82, 0);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/dashboard/Inbox2.vue